import { StateToken } from '@ngxs/store';

import { ExternalUnits, UnitConfigurationPerformanceData, UnitSimulationAccessory } from '../../models';

export interface UnitConfigurationStateModel {
  currentSimulationAccessories: UnitSimulationAccessory[] | undefined;
  updatingAccessories: boolean;
  performanceData: UnitConfigurationPerformanceData;
  externalUnitContainer: ExternalUnits;
}

export const UNIT_CONFIGURATION_STATE_TOKEN = new StateToken<UnitConfigurationStateModel>('unitConfiguration');
